import { render, staticRenderFns } from "./AddressesPicker.vue?vue&type=template&id=3aed9587&lang=pug"
import script from "./AddressesPicker.vue?vue&type=script&lang=js"
export * from "./AddressesPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports